export default class InputGetList
{
  constructor(pageSize, pageNumber, searchText, orderBy, propertyName, visible) 
  {
    this.pageSize = pageSize;
    this.pageNumber = pageNumber;
    this.searchText = searchText;
    this.orderBy = orderBy;
    this.propertyName = propertyName;
    this.visible = visible;
    this.sorter = null; // Will be set to 'ascending' or 'descending'
  }    
}